module.exports = __webpack_public_path__ + "img/no-pic-mbzs.e36da709.png";